import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { GRADUATION } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/graduation/")({
  component: () => <DeptContentList cfg={GRADUATION} />,
});
